import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const IssueStartedIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => {
		return (
			<svg
				viewBox="0 0 14 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
				ref={ref}
			>
				<circle
					cx="7"
					cy="7"
					r="6"
					fill="none"
					stroke={props.color || "currentColor"}
					strokeWidth="2"
					strokeDasharray="3.14 0"
					strokeDashoffset="-0.7"
				/>
				<circle
					className="progress"
					cx="7"
					cy="7"
					r="2"
					fill="none"
					stroke={props.color || "currentColor"}
					strokeWidth="4"
					strokeDasharray="3.1258846903218442 100"
					strokeDashoffset="0"
					transform="rotate(-90 7 7)"
				/>
			</svg>
		)
	},
)
